export default __webpack_public_path__ + "static/ay-support-content-go-to-app-d6a1d028bf55094777e80ca82f0fabb9.svg";